import Popup from "@wwdev/webshop/v2/popup";
import Flickity from "flickity";

class CustomPopup extends Popup {
	afterCall($button) {
		super.afterCall($button);
		let $flickity = $button.closest('.flickity-carousel');
		this._resizeFlickity($flickity);
	}

	_resizeFlickity($flickity) {
		if ($flickity.length < 1) {
			return
		}
		let flickity = Flickity.data($flickity[0]);
		flickity.resize();
	}
}

export default CustomPopup;